import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Button, Input } from '@node-space/ui-components'

interface RewardsAmountInputProps {
  selectedCurrency: string
  maxAmount: string
  disabled?: boolean
  label?: string
  placeholderText?: string
  testId?: string
  hideMaxButton?: boolean
}

export const RewardsAmountInput: React.FC<RewardsAmountInputProps> = ({
  selectedCurrency,
  maxAmount,
  disabled = false,
  label,
  placeholderText = '0.00',
  testId = 'amount-input',
  hideMaxButton = false,
}) => {
  const { t } = useTranslation()
  const { control } = useFormContext()

  const displayLabel = label || t('amount')

  return (
    <Controller
      control={control}
      name="amount"
      render={({ field, fieldState: { error } }) => (
        <Input
          {...field}
          testId={testId}
          label={displayLabel}
          disabled={disabled}
          placeholderText={placeholderText}
          helperText={
            hideMaxButton
              ? undefined
              : t('rewards.withdraw.maxAmount', {
                  amount: `${maxAmount || '-'} ${selectedCurrency}`,
                })
          }
          rightSuffixText={selectedCurrency}
          LabelButton={
            hideMaxButton ? undefined : (
              <Button
                variant="ghost"
                disabled={!maxAmount || Number.parseFloat(maxAmount) <= 0}
                onClick={() => {
                  field.onChange(maxAmount)
                }}
              >
                {t('max')}
              </Button>
            )
          }
          error={!!error?.message}
          errorText={error?.message}
        />
      )}
    />
  )
}
